import React from 'react';
import { connect } from 'react-redux';
import SaveUserGroupDialog from './SaveUserGroupDialog';
import DeleteUserGroupDialog from './DeleteUserGroupDialog';

const UserGroupsDialogs = ({ allowCreate, allowDelete, theme }) => (
  <>
    {allowCreate && (<SaveUserGroupDialog theme={theme} />)}
    {allowDelete && <DeleteUserGroupDialog theme={theme} />}
  </>
);

const mapStateToProps = ({
  auth: { role: { permissions: { usergroups: { create, destroy } } } },
  userGroups: { activeUserGroup, deleteUserGroupOpen },
}) => ({
  allowCreate: activeUserGroup.open && create,
  allowDelete: deleteUserGroupOpen && destroy,
});

export default connect(mapStateToProps)(UserGroupsDialogs);
